import React from "react";

const Applications = () => {
  const applications = [
    {
      name: "Brian Kiprono Chebet",
      gender: "Male",
      dob: "15 Jun 2013",
      age: 11,
      grade: "Grade 6",
      enrollmentDate: "6 Jan 2025",
    },
    {
      name: "Faith Wanjiku Mwangi",
      gender: "Female",
      dob: "3 Oct 2012",
      age: 12,
      grade: "Grade 7",
      enrollmentDate: "6 Jan 2025",
    },
    {
      name: "Collins Otieno Ouma",
      gender: "Male",
      dob: "22 Apr 2015",
      age: 10,
      grade: "Grade 5",
      enrollmentDate: "5 May 2025",
    },
    {
      name: "Sharon Achieng Okoth",
      gender: "Female",
      dob: "11 Aug 2011",
      age: 13,
      grade: "Grade 8",
      enrollmentDate: "6 Jan 2025",
    },
    {
      name: "Kelvin Kamau Njuguna",
      gender: "Male",
      dob: "9 Jan 2016",
      age: 9,
      grade: "Grade 4",
      enrollmentDate: "5 May 2025",
    },
    {
      name: "Mercy Atieno Owino",
      gender: "Female",
      dob: "30 Mar 2014",
      age: 11,
      grade: "Grade 6",
      enrollmentDate: "6 Jan 2025",
    },
    {
      name: "Dennis Kipkemoi Langat",
      gender: "Male",
      dob: "25 Nov 2010",
      age: 14,
      grade: "Grade 9",
      enrollmentDate: "6 Jan 2025",
    },
    {
      name: "Jane Naserian Ole Letuya",
      gender: "Female",
      dob: "14 Jul 2013",
      age: 11,
      grade: "Grade 6",
      enrollmentDate: "6 Jan 2025",
    },
    {
      name: "Victor Ndirangu Wainaina",
      gender: "Male",
      dob: "18 Feb 2012",
      age: 13,
      grade: "Grade 7",
      enrollmentDate: "6 Jan 2025",
    },
    {
      name: "Elizabeth Wanjiru Kariuki",
      gender: "Female",
      dob: "8 May 2011",
      age: 14,
      grade: "Grade 8",
      enrollmentDate: "6 Jan 2025",
    },
  ];

  return (
    <>
      <div className="flex justify-between items-center">
        <span className="label-subtitle">Applications</span>
        {/* <button className="button-small-primary">+ Add</button> */}
      </div>
      <div className="overflow-x-auto mt-2">
        <table className="min-w-full text-left text-sm bg-white rounded-xl text-gray-800">
          <thead>
            <tr className="border-b border-gray-300">
              <th className="px-4 py-3 font-medium">Student Name</th>
              <th className="px-4 py-3 font-medium">Gender</th>
              <th className="px-4 py-3 font-medium">Date of Birth</th>
              <th className="px-4 py-3 font-medium">Age</th>
              <th className="px-4 py-3 font-medium">Grade Requested</th>
              <th className="px-4 py-3 font-medium">
                Preferred Enrolment Date
              </th>
            </tr>
          </thead>
          <tbody>
            {applications.map((app, index) => (
              <tr key={index} className="border-b border-gray-200">
                <td className="px-4 py-3">{app.name}</td>
                <td className="px-4 py-3">{app.gender}</td>
                <td className="px-4 py-3">{app.dob}</td>
                <td className="px-4 py-3">{app.age}</td>
                <td className="px-4 py-3">{app.grade}</td>
                <td className="px-4 py-3">{app.enrollmentDate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Applications;
